import axios from 'axios';
import { IS_MOCK_API } from '../comm/config';
import { store } from '../redux';
import { setVersion as setReduxVersion } from '../redux/actions';

const URL = '/wpversion';

let version = null;
let oldVersion = null;
let lastTimeout = null;
const verFunc = {
  getRequest: async function () {
    let result = null;
    if (IS_MOCK_API) {
      result = { data: '-1.00.00' };
    } else {
      result = await axios.get(URL);
    }
    return result?.data;
  },
  setVersion: async function () {
    if (version === null) {
      try {
        version = await this.getRequest();
        oldVersion = version;
        // set timeout to clear version
        lastTimeout && clearTimeout(lastTimeout);
        lastTimeout = setTimeout(() => {
          oldVersion = version;
          version = null;
        }, 1800);
      } catch {
        version = oldVersion;
      }
    }
  },
  getVersion: async function () {
    await this.setVersion();
    const maskVersion = version
      ? version.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;')
      : version;
    store.dispatch(setReduxVersion(maskVersion));
    return maskVersion;
  },
};

export { verFunc };
